export default __webpack_public_path__ + "77540ff2de37b15aea5d523eddd323db.svg";